/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const relatedVehiclesNodes = Array.from(document.querySelectorAll('.related-vehicles'));
if (relatedVehiclesNodes.length) {
    import(/* webpackChunkName: "RelatedVehicles" */ './components/RelatedVehicles').then(({ default: RelatedVehicles }) => {
        relatedVehiclesNodes.forEach((node) => render(<RelatedVehicles {...parseDataToProps(node.dataset)}/>, node));
    });
}
